<div class="payroll-page">
  <div class="page-header">
    <div>
      <h1>Paie</h1>
      <p class="subtitle">Préparation des relevés d'activité et suivi des bulletins (Sage Paie)</p>
    </div>
    <div class="prepare-box">
      <input type="month" [(ngModel)]="selectedMonth" [disabled]="preparing" />
      <button class="btn btn-primary" (click)="prepare()" [disabled]="preparing || !selectedMonth">
        {{ preparing ? 'Préparation...' : 'Préparer la période' }}
      </button>
      <button class="btn-refresh" (click)="load()" [disabled]="loading">Rafraîchir</button>
    </div>
  </div>

  @if (loading) {
    <div class="empty-state">Chargement...</div>
  } @else if (periods.length === 0) {
    <div class="empty-state">
      Aucune période de paie. Sélectionnez un mois puis cliquez sur « Préparer la période ».
    </div>
  } @else {
    <div class="periods-table">
      <div class="table-row table-head">
        <div>Période</div>
        <div>Statut</div>
        <div>Dernière mise à jour</div>
        <div>Actions</div>
      </div>
      @for (p of periods; track p.id) {
        <div class="table-row table-data" (click)="open(p)">
          <div class="period-name">{{ p.period }}</div>
          <div>
            <span class="status-pill"
              [class.draft]="p.status === 'DRAFT'"
              [class.prepared]="p.status === 'PREPARED'"
              [class.sent]="p.status === 'SENT'"
              [class.received]="p.status === 'PAYSLIPS_RECEIVED'"
              [class.closed]="p.status === 'CLOSED'">
              {{ statusLabel(p.status) }}
            </span>
          </div>
          <div>{{ (p.updateDate || p.creationDate) | date:'dd/MM/yy HH:mm' }}</div>
          <div class="actions">
            <button class="btn btn-secondary btn-sm" (click)="open(p); $event.stopPropagation()">
              Ouvrir
            </button>
          </div>
        </div>
      }
    </div>
  }
</div>
